import React, { useState } from "react";
import { db } from "./firebase";
import { doc, setDoc } from "firebase/firestore";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "I am new user",
  });

  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const addUser = async (e) => {
    e.preventDefault();
    setShowSuccessMessage(false);

    if (!formData.name || !formData.email || !formData.phone) {
      setShowError(true);
      return;
    }

    setShowError(false);
    setLoading(true);

    try {
      const userDocRef = doc(db, "new_users", formData.email);
      await setDoc(userDocRef, { ...formData });

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "I am new user",
      });

      setShowSuccessMessage(true);
    } catch (error) {
      console.error("Error adding document: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const x = (clientX / window.innerWidth - 0.5) * 10; // Adjust intensity
    const y = (clientY / window.innerHeight - 0.5) * 10; // Adjust intensity
    setMousePosition({ x, y });
  };

  return (
    <div
      className="min-h-screen bg-[inherit] flex flex-col items-center justify-center px-2 py-4"
      onMouseMove={handleMouseMove}
    >
      <div
        className="bg-white shadow-2xl rounded-2xl p-10 max-w-4xl w-full transition-transform duration-300"
        style={{
          transform: `perspective(1000px) rotateX(${mousePosition.y}deg) rotateY(${mousePosition.x}deg)`,
        }}
      >
        <h2 className="text-4xl font-extrabold text-center text-[#2d3192] mb-8">
          Build Your Strategy
        </h2>
        <ul className="text-gray-600 mb-8 space-y-2 text-lg leading-relaxed">
          <li>Need help coding your strategy?</li>
          <li>Worried about your coder stealing your system?</li>
          <li>Difficulties in conveying your ideas to the developer?</li>
          <li>
            <span className="text-[#008000] font-semibold">NO MORE!</span>{" "}
            AlgoTurtle is here to help. We specialize in making custom
            strategies for our users, complete backtesting, and strategy
            configuration using our Turtle AI.
          </li>
          <li>
            Every user is provided with a specialist who guides them through the
            entire strategy-building process. Your strategy remains your
            intellectual property.
          </li>
          <li>
            <span className="text-[#2d3192] font-semibold">
              *Tick-wise data
            </span>
            ,{" "}
            <span className="text-[#2d3192] font-semibold">
              *Faster execution speeds
            </span>
            ,{" "}
            <span className="text-[#2d3192] font-semibold">
              *Reliable coding practices
            </span>
          </li>
        </ul>
        <form onSubmit={addUser} className="space-y-6">
          <div>
            <input
              id="name"
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d3192] text-sm"
              required
            />
          </div>
          <div>
            <input
              id="email"
              type="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d3192] text-sm"
              required
            />
          </div>
          <div>
            <input
              id="phone"
              type="tel"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d3192] text-sm"
              required
            />
          </div>
          <div>
            <textarea
              id="message"
              rows="4"
              placeholder="Your Message (I am new user)"
              value={formData.message}
              onChange={handleChange}
              className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2d3192] text-sm"
              required
            />
          </div>
          {showError && (
            <p className="text-red-500 text-sm">
              Please fill in all the required fields.
            </p>
          )}
          {showSuccessMessage && (
            <p className="text-green-500 text-sm">
              Thank you for reaching out! Your details have been successfully
              submitted. We will get in touch with you as soon as possible.
            </p>
          )}
          <button
            type="submit"
            className={`w-full py-4 text-white font-bold rounded-lg transition-all text-m ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#2d3192] hover:bg-[#008000]"
            }`}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
